// -*- Mode: rjsx -*-
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ChatIcon from '@mui/icons-material/Chat';

import { FHMaterialStyles, addSuccess } from '../../../ui';

import { API } from '../../../api';

import { updateRequest } from '../../request';
import { ResponseOption, ResponseTextEntry, doClose, clearCache, getCacheKey } from '..';

function CloseSheet(props) {
    const dispatch = useDispatch();
    const [sending, setSending] = useState(false);    
    const cacheKey = getCacheKey(props);

    const classes = FHMaterialStyles();
    
    const [text, setText] = useState(null);
    
    function change(value, numberOfIssues) {
        setText(value);
    }
    
    function send(requestKey) {
        
        setSending(true);

        
        dispatch(doClose({
            requestKey: requestKey,
            text: text
        })).then((data) => {
            
            setSending(false);

            dispatch(clearCache(cacheKey));
            dispatch(updateRequest(data.payload.request));
            
            if(props.onResponseSuccess)
                props.onResponseSuccess(data);
            
        });
        

    }



    return <ResponseTextEntry
             sending={sending}
             sendButtonTitle="Save &amp; Close"
             onSend={send}
             onChange={change}
             {...props} />;


}


function CloseResponse(props) {
    
    const primary = "Answer this now";
    const secondary = "Close this request";
    const icon = <ChatIcon />;
    
    props = {
        type: "close",
        primary: primary,
        secondary: secondary,
        icon: icon,        
        submit:  { text: "Send & Close" },
        ...props
    };
    
    return (
        <ResponseOption
          {...props }
          sheet={<CloseSheet {...props}  />}
        />
    );
}

export { CloseResponse };
